import { createApp } from 'vue';
import { createPinia } from 'pinia'
import { useKioskStore } from '@/stores/useKioskStore';
import { useThemeStore } from '@/stores/useThemeStore';
import { useTranslationsStore } from '@/stores/useTranslationsStore';
import { useCatalogStore } from '@/stores/useCatalogStore';
import App from './App.vue';
import router from './router';
import './assets/styles/main.scss';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

router.isReady().then(async () => {
    const route = router.currentRoute.value;
    const kioskId = route.params.kioskId;
    const { fetchKiosk } = useKioskStore();

    await fetchKiosk(kioskId);

    const { initTheme } = useThemeStore();
    const { fetchTranslations } = useTranslationsStore();
    const { fetchCatalog } = useCatalogStore();

    await Promise.all([
      initTheme(),
      fetchTranslations(),
      fetchCatalog(),
    ]);

    insertGoogleFontsPreconnect();

    app.mount('#app');
});

function insertGoogleFontsPreconnect() {
    if (document.getElementById('gf-preconnect-googleapis')) return;

    const googleapis = document.createElement('link');
    googleapis.rel = 'preconnect';
    googleapis.href = 'https://fonts.googleapis.com';
    googleapis.id = 'gf-preconnect-googleapis';

    const gstatic = document.createElement('link');
    gstatic.rel = 'preconnect';
    gstatic.href = 'https://fonts.gstatic.com';
    gstatic.crossOrigin = '';
    gstatic.id = 'gf-preconnect-gstatic';

    document.head.appendChild(googleapis);
    document.head.appendChild(gstatic);
}
